/**
 * @internalapi
 */
export class WalletConnectPairingRequest {
    type = 'walletconnect-pairing-request';
    uri;
    id;
    name;
    icon;
    appUrl;
    publicKey;
    version;
    constructor(id, name, publicKey, version, uri, icon, appUrl) {
        this.id = id;
        this.name = name;
        this.icon = icon;
        this.appUrl = appUrl;
        this.publicKey = publicKey;
        this.version = version;
        this.uri = uri;
    }
}
/**
 * @internalapi
 */
export class ExtendedWalletConnectPairingRequest extends WalletConnectPairingRequest {
    senderId;
    constructor(id, name, publicKey, version, senderId, uri, icon, appUrl) {
        super(id, name, publicKey, version, uri, icon, appUrl);
        this.senderId = senderId;
    }
}
//# sourceMappingURL=WalletConnectPairingRequest.js.map